"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewStudentsSelector = void 0;
var _hooks = require("../../../hooks");
var _AudiencePicker = require("../AudiencePicker.labels");
var _SliderLayout = require("../../../Layout/SliderLayout");
var _GroupName = require("./partials/GroupName");
var _SingleStudents = require("./partials/SingleStudents");
var _Error = require("./partials/Error");
var _jsxRuntime = require("react/jsx-runtime");
const ViewStudentsSelector = props => {
  const {
    setViewAndIndex,
    viewIndex,
    createGroupTempData,
    saveGroup,
    onSelectedChanged,
    selectedGroupsIds,
    selectedClassesIds,
    studentsSelectorTempData,
    selectedStudentsIds,
    createGroupErrorMessage = ''
  } = props;
  const getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  const hasChanges = selectedStudentsIds?.length !== studentsSelectorTempData?.selectedStudentsIds.length || studentsSelectorTempData && studentsSelectorTempData.selectedStudentsIds.filter(id => selectedStudentsIds && selectedStudentsIds.indexOf(id) < 0).length > 0;
  const handleInputGroupNameConfirm = () => {
    if (createGroupTempData && createGroupTempData.groupName && createGroupTempData.groupName.length > 0) {
      saveGroup('inline', 0, 'studentsSelector', 2, true);
    }
  };
  const handleInputGroupNameCancel = () => {
    setViewAndIndex('studentsSelector', 0);
  };
  const handleSingleStudentsCancel = () => {
    setViewAndIndex('inline', 0);
  };
  const handleSingleStudentsConfirm = () => {
    if (hasChanges && onSelectedChanged) {
      onSelectedChanged({
        selectedGroupsIds: selectedGroupsIds,
        selectedClassesIds: selectedClassesIds,
        selectedStudentsIds: [...(studentsSelectorTempData && studentsSelectorTempData.selectedStudentsIds || [])]
      });
    }
    setViewAndIndex('inline', 0);
  };
  const handleErrorGoBack = () => {
    setViewAndIndex('studentsSelector', 1);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderLayout.SliderLayout, {
      width: "100%",
      index: viewIndex.studentsSelector,
      items: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleStudents.SingleStudents, {
        ...props,
        onCancel: handleSingleStudentsCancel,
        onConfirm: handleSingleStudentsConfirm,
        isConfirmEnabled: hasChanges
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GroupName.GroupName, {
        ...props,
        onCancel: handleInputGroupNameCancel,
        onConfirm: handleInputGroupNameConfirm
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error.Error, {
        ...props,
        title: getLabel(createGroupErrorMessage),
        subTitle: getLabel('create_group_error_sub_title'),
        onGoBack: handleErrorGoBack
      })]
    })
  });
};
exports.ViewStudentsSelector = ViewStudentsSelector;